module.exports = __webpack_public_path__ + "f94ff66b4ed57207bf30bd901520f134.png";